import React, { Component } from 'react'
import { connect } from 'react-redux'
import withOverview from './withOverview'
import Programs from './Programs'
import { LOADING_SUCCEEDED } from '../../../root/reducers/reports/utils'

import { withUser } from '../../../common/AuthenticationProvider'
import withConfig from '../../../van-shared/hoc/withConfig'
import ProgramErrorBanner from './ProgramsError'

class ProgramsContainer extends Component {
  render () {
    const {
      locationId,
      date,
      config,
      user,
      loadingStatus,
      showCountSyncBanner,
      showShipmentSyncBanner
    } = this.props
    let { overviews } = this.props
    const loadedOverviews = overviews.filter(overview => !overview.isOverviewLoading)

    if (loadedOverviews.length === 0 && loadingStatus === LOADING_SUCCEEDED) {
      return (
        <ProgramErrorBanner />
      )
    }

    return (
      <Programs
        config={config}
        programs={overviews}
        locationId={locationId}
        date={date}
        user={user}
        showCountSyncBanner={showCountSyncBanner}
        showShipmentSyncBanner={showShipmentSyncBanner}
      />
    )
  }
}

const mapStateToProps = (
  { overview: { overviews, status: loadingStatus } },
  { match: { params: { locationId, date } } }
) => {
  return {
    locationId,
    date,
    overviews: overviews || [],
    loadingStatus
  }
}

export default withConfig(withUser(connect(mapStateToProps)(withOverview(ProgramsContainer))))
